class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.header');
    this.lastScroll = 0;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const scroll = window.scrollY;
    if (scroll > 100 && scroll > this.lastScroll) {
      this.classList.add('header--hidden');
    } else {
      this.classList.remove('header--hidden');
    }
    this.lastScroll = scroll;
  }
}
customElements.define('sticky-header', StickyHeader);

class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.toggle = document.querySelector('[aria-controls="mobile-menu-drawer"]');
    this.overlay = this.querySelector('[data-menu-overlay]');
    this.closeBtn = this.querySelector('[data-menu-close]');

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.open());
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    this._onKeydown = this._onKeydown.bind(this);
  }

  open() {
    this.removeAttribute('hidden');
    requestAnimationFrame(() => {
      this.classList.add('is-open');
    });
    this.toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKeydown);
    this.closeBtn.focus();
  }

  close() {
    this.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKeydown);

    const onEnd = () => {
      if (!this.classList.contains('is-open')) {
        this.setAttribute('hidden', '');
      }
    };
    this.addEventListener('transitionend', onEnd, { once: true });
    /* Fallback in case transitionend doesn't fire */
    setTimeout(onEnd, 350);

    this.toggle.focus();
  }

  /* ── Keyboard Handling (Escape + Focus Trap) ── */

  _onKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
      return;
    }

    if (e.key !== 'Tab') return;

    /* Focus trap: keep Tab cycling within the menu drawer */
    const focusable = this.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
}
customElements.define('menu-drawer', MenuDrawer);
